export const actions = {
  async fetchTaxRatesForAddress({ dispatch }, { address1, address2, city, state, zip }) {
    const response = await dispatch('request/get', {
      url: `/api/tax/rates/address?address1=${address1}&address2=${address2}&city=${city}&state=${state}&zip=${zip}`,
      errorMessage: 'Failed to get tax rates for provided address.',
    });

    return response?.data ?? null;
  },
};
